(function () {
	if (window.__oaCampaignPriceInitialized) return
	window.__oaCampaignPriceInitialized = true

	const CAMPAIGNS = {
		'expressen-clean': {
			'clean-60': {
				code: 'BNEA1H4WCGRP',
			},
			'clean-120': {
				code: '2T7XW1ZMSSYA',
			},
		},
		'luftrenare-deal05': {
			'purify-120-pro': {
				code: 'DEAL05',
			},
		},
		'luftrenare-sen120': {
			'purify-120-pro': {
				code: 'SEN120',
			},
		},
	}

	function getCampaignRoots(scope) {
		const root = scope instanceof Element || scope instanceof Document ? scope : document
		return Array.from(root.querySelectorAll('[data-campaign-price-root]'))
	}

	function getCampaignParam() {
		return new URL(window.location.href).searchParams.get('oa_campaign')
	}

	function getDiscountParam() {
		return new URL(window.location.href).searchParams.get('discount')
	}

	function normalizeDiscountCode(discountCode) {
		return (discountCode || '').trim().toUpperCase()
	}

	function getDiscountCodeCookie() {
		// Verified on ozoneair.se on 2026-05-11. This cookie is only used to
		// bootstrap an in-session campaign context on approved landing sections.
		const match = document.cookie.match(/(?:^|; )discount_code=([^;]+)/)
		return match ? decodeURIComponent(match[1]) : null
	}

	function getEligibleCampaignKeys(root, productHandle) {
		const rawCampaignKeys = (root.dataset.campaignKeys || '')
			.split(',')
			.map((value) => value.trim())
			.filter(Boolean)

		return rawCampaignKeys.filter(function (campaign) {
			return Boolean(CAMPAIGNS[campaign] && CAMPAIGNS[campaign][productHandle])
		})
	}

	function getStorageKey(campaign, productHandle) {
		return 'oa-campaign-price:' + campaign + ':' + productHandle
	}

	function getSessionValue(key) {
		try {
			return window.sessionStorage.getItem(key)
		} catch {
			return null
		}
	}

	function setSessionValue(key, value) {
		try {
			window.sessionStorage.setItem(key, value)
		} catch {
			return null
		}
	}

	function isRedirectNavigation() {
		try {
			const navigationEntries = window.performance.getEntriesByType('navigation')
			const navigationEntry = navigationEntries && navigationEntries[0]

			if (
				navigationEntry &&
				typeof navigationEntry.redirectCount === 'number'
			) {
				return navigationEntry.redirectCount > 0
			}
		} catch {}

		if (
			window.performance &&
			window.performance.navigation &&
			typeof window.performance.navigation.redirectCount === 'number'
		) {
			return window.performance.navigation.redirectCount > 0
		}

		return false
	}

	function canActivateFromDiscountCookie(root) {
		return (
			root.dataset.allowDiscountCookieActivation === 'true' &&
			isRedirectNavigation()
		)
	}

	function canActivateFromDiscountParam(root) {
		return root.dataset.allowDiscountUrlParamActivation === 'true'
	}

	function findCampaignByDiscountCode(productHandle, discountCode, campaignKeys) {
		const normalizedDiscountCode = normalizeDiscountCode(discountCode)

		if (!normalizedDiscountCode) return null

		for (const campaign of campaignKeys) {
			const campaignConfig = CAMPAIGNS[campaign]
			const productConfig = campaignConfig[productHandle]

			if (
				productConfig &&
				normalizeDiscountCode(productConfig.code) === normalizedDiscountCode
			) {
				return campaign
			}
		}

		return null
	}

	function persistCampaignContext(root) {
		const productHandle = root.dataset.productHandle
		const campaign = getCampaignParam()
		const eligibleCampaignKeys = getEligibleCampaignKeys(root, productHandle)

		if (!productHandle || !campaign) return
		if (!eligibleCampaignKeys.includes(campaign)) return

		root.dataset.activeCampaign = campaign
		setSessionValue(
			getStorageKey(campaign, productHandle),
			normalizeDiscountCode(CAMPAIGNS[campaign][productHandle].code)
		)
	}

	function resolveCampaign(root) {
		const productHandle = root.dataset.productHandle
		const eligibleCampaignKeys = getEligibleCampaignKeys(root, productHandle)

		if (!productHandle) return null
		if (!eligibleCampaignKeys.length) return null

		persistCampaignContext(root)

		if (
			root.dataset.activeCampaign &&
			eligibleCampaignKeys.includes(root.dataset.activeCampaign)
		) {
			return root.dataset.activeCampaign
		}

		if (!root.dataset.activeCampaign && canActivateFromDiscountParam(root)) {
			const discountParam = getDiscountParam()
			if (discountParam) {
				const paramCampaign = findCampaignByDiscountCode(
					productHandle,
					discountParam,
					eligibleCampaignKeys
				)
				if (paramCampaign) {
					root.dataset.activeCampaign = paramCampaign
					return paramCampaign
				}
			}
		}

		for (const campaign of eligibleCampaignKeys) {
			const campaignConfig = CAMPAIGNS[campaign][productHandle]

			const storedCode = getSessionValue(getStorageKey(campaign, productHandle))

			if (
				normalizeDiscountCode(storedCode) ===
				normalizeDiscountCode(campaignConfig.code)
			) {
				root.dataset.activeCampaign = campaign
				return campaign
			}
		}

		if (!canActivateFromDiscountCookie(root)) return null

		const cookieCampaign = findCampaignByDiscountCode(
			productHandle,
			getDiscountCodeCookie(),
			eligibleCampaignKeys
		)

		if (!cookieCampaign) return null

		root.dataset.activeCampaign = cookieCampaign
		setSessionValue(
			getStorageKey(cookieCampaign, productHandle),
			normalizeDiscountCode(CAMPAIGNS[cookieCampaign][productHandle].code)
		)

		return cookieCampaign
	}

	function getCampaignCard(root) {
		return root.closest('[data-campaign-product-card]')
	}

	function getRedirectTarget(baseUrl, campaign) {
		const redirectUrl = new URL(baseUrl, window.location.origin)
		redirectUrl.searchParams.set('oa_campaign', campaign)

		return redirectUrl.pathname + redirectUrl.search + redirectUrl.hash
	}

	function buildCampaignLink(baseUrl, campaign, productHandle) {
		const campaignConfig = CAMPAIGNS[campaign] && CAMPAIGNS[campaign][productHandle]

		if (!campaignConfig) return baseUrl

		return (
			'/discount/' +
			encodeURIComponent(campaignConfig.code) +
			'?redirect=' +
			encodeURIComponent(getRedirectTarget(baseUrl, campaign))
		)
	}

	function updateCampaignLinks(root, campaign) {
		const card = getCampaignCard(root)
		const productHandle = root.dataset.productHandle

		if (!card || !productHandle) return

		card.querySelectorAll('[data-campaign-link]').forEach(function (link) {
			const baseUrl = link.dataset.baseUrl || link.getAttribute('href')

			if (!baseUrl) return

			link.setAttribute(
				'href',
				campaign ? buildCampaignLink(baseUrl, campaign, productHandle) : baseUrl
			)
		})
	}

	function applyCampaignPrice(root) {
		// Campaign context controls navigation only. Shopify-rendered catalogue
		// and compare-at prices remain authoritative until checkout applies a code.
		updateCampaignLinks(root, resolveCampaign(root))
	}

	function observeCampaignRoot(root) {
		if (root.campaignPriceObserver) return

		applyCampaignPrice(root)

		root.campaignPriceObserver = new MutationObserver(function () {
			applyCampaignPrice(root)
		})

		root.campaignPriceObserver.observe(root, {
			childList: true,
			subtree: true,
		})
	}

	function initCampaignPrices(scope) {
		getCampaignRoots(scope).forEach(function (root) {
			observeCampaignRoot(root)
		})
	}

	document.addEventListener('DOMContentLoaded', function () {
		initCampaignPrices(document)
	})

	document.addEventListener('shopify:section:load', function (event) {
		initCampaignPrices(event.target)
	})

	if (document.readyState !== 'loading') {
		initCampaignPrices(document)
	}
})()
